/**
 * Created by fers on 05.02.16.
 */
/* @flow */

import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import types from '../../common/model-api/types';
import Relay from 'react-relay';
import {injectIntl, defineMessages} from 'react-intl';

import Editor from '../fw/Editor.react';
import urlMapping from '../app/URLMapping';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';

const messages = defineMessages({
    title: {id: 'screenAdd.title', 'defaultMessage': 'Adding screen'}
});

class ScreenAdd extends React.Component {

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };
    typeName = 'screens';

    constructor(props) {
        super(props);

    }

    render() {
        let type = types[this.typeName];

        let entities = this.props.user.organisation.channel.channelDef.channelEntityDefs.edges.map(({node}) => node);


        return (
            <AppPanel breadcrumbParams={[
                {type: types['channels'], data: this.props.user.organisation.channel},
                {type: types['organisations'], data: this.props.user.organisation}]
            } title={this.props.intl.formatMessage(messages.title)}>
                <Editor
                    columns={{
                        'channelEntityDef': {
                            display: (item) => {
                                return item['entityDef']['name'] + " (" + item['entityDef']['groupDef']['name'] + ")";
                            },
                            values: entities,
                        },
                        'operation': {},
                        'subOperation': {},
                    }}
                    extraConfig={[{
                              type: 'RANGE_ADD',
                              parentName: 'organisation',
                              parentID: this.props.user.organisation.channel.id,
                              connectionName: 'screens',
                              edgeName: 'edge',
                              rangeBehaviors: {
                                '': 'append',
                              },
                    }]}
                    fatQuery={Relay.QL `fragment on CreateScreenPayload @relay(pattern: true) {
                        edge {
                            node {
                                id,
                            }
                        },
                        channel {
                            screens(first: 100) {
                                edges {
                                    node {
                                        id
                                    }
                                }
                            }
                        }
                    }`}
                    isCreate
                    metadata={type}
                    mutation={Relay.QL `mutation { createScreen }`}
                    organisationId={this.props.user.organisation.realId}
                    parent={this.props.user.organisation.channel}
                    redirectToList
                    urlMapping={urlMapping}
                />
            </AppPanel>
        );
    }
}


export default Relay.createContainer(wrapNotFound(injectIntl(ScreenAdd), (props) => {
    return props.user.organisation && props.user.organisation.channel;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    realId,
                    name,
                    channel(id: $channelId) {
                        id,
                        name,
                        channelDef {
                            id,
                            channelEntityDefs(first: 100) {
                                edges {
                                    node {
                                        id,
                                        entityDef {
                                            id,
                                            name,
                                            groupDef {
                                                id,
                                                name
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                },
            }
        `,
    },
});
